import React, { useEffect } from 'react'
import { DefaultLayout } from '../../layouts'
import { SimplePageHeader } from '../../components'
import { PageContent } from './components'
import queryString from 'query-string'
import { useInternationalization } from '../../features/i18n'
import { setQueryString } from '../../features/search/slice'
import { useDispatch } from 'react-redux'
import AudienceListener from '../../features/collection/components/audience-listener'

// 20210222 - deprecated

const SearchResults = (props) => {
  const dispatch = useDispatch()
  const { translate } = useInternationalization()
  const query = queryString.parse(props.location.search)

  useEffect(() => {
    dispatch(setQueryString(props.location.search))
    // eslint-disable-next-line
  }, [])

  return (
    <DefaultLayout>
      <AudienceListener />
      <SimplePageHeader title={translate('SEARCH', 'search_results')} />
      <PageContent query={query} />
    </DefaultLayout>
  )
}

export { SearchResults }
